import Vue from 'vue'
import Vuex from 'vuex'
// import VuexPersist from 'vuex-persist';
// import {is_Empty, hasMemberType} from "../utils"
import state from "./state";
import getters from "./getters";
import mutations from "./mutations";

// 创建对象，借助浏览器缓存，存入localStorage
// const vuexLocal = new VuexPersist({
//     storage: window.localStorage  // 可选，sessionStorage/indexDB
// })
Vue.use(Vuex)

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions: {},
    // plugins: [vuexLocal.plugin]
})